module.exports = __webpack_public_path__ + "files/1b00dbf2a04d20cf90bc15be346a0f40.svg";